import { biggerOrTo } from '../../render-helper';
import { translateText } from '@op/pages/Influencer/utils/text';

export default function influencerPublicationAnalysisCounts(params: any) {
  let { INNER_METRIC_TYPE, media_types } = params;

  return [
    {
      header: 'Time',
      render: 'time',
    },
    {
      header: 'Type',
      render: 'name',
      renderHelper: [
        (item: { [x: string]: string }, key: string | number) => {
          return translateText(
            item[key],
            INNER_METRIC_TYPE,
            (value: string) => {
              if (media_types[0] === 'stream' && INNER_METRIC_TYPE === 'posts')
                return 'Streaming';
              return value;
            },
          );
        },
      ],
    },
    {
      header: 'Counts',
      render: 'value',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
  ];
}
